export default __webpack_public_path__ + "static/media/USA.a4e95831.png";